import {CreativeBean} from 'common/api/api.ts'

export const contextOptions = ['Content Feeds', 'Product Feeds', 'Social Feeds', 'Others']
export const placementOptions = ['In Content', 'In Feed', 'Outside Content', 'Widget Below', 'Others']

export const nativeIconSizeList = new Map<string, { name: string; width: number; height: number }>([
  ['100x100', { name: '100x100', width: 100, height: 100 }],
  ['192x192', { name: '192x192', width: 192, height: 192 }],
  ['256x256', { name: '256x256', width: 256, height: 256 }],
])

export const nativeImageSizeList = new Map<string, { name: string; width: number; height: number }>([
  ['627x627', { name: '627x627', width: 627, height: 627 }],
  ['1200x627', { name: '1200x627', width: 1200, height: 627 }],
])

export const pushIconWidth = 192
export const pushIconHeight = 192
export const pushImageWidth = 720
export const pushImageHeight = 480
export const nativeIconWidth = 100
export const nativeIconHeight = 100
export const nativeImageWidth = 1200
export const nativeImageHeight = 627

export const statusColors: Record<string, string> = {
  [CreativeBean.StatusEnum.Approved]: 'green',
  [CreativeBean.StatusEnum.Pending]: '#E6E6E6',
  [CreativeBean.StatusEnum.Refused]: 'red'
}
